import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('lender_setting', {
  lender_id: '',
  pipeline_sort: '',
  dashboard_sort: '',
  hidden_dashboard_columns: [],
})
